module.exports = __webpack_public_path__ + "static/media/sunset.d6a5726d.jpg";